import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

export class Association {
    public id: number = 0;
    public name?: string;
    public ownerId: number = 0;
    public ownerEmail?: string;
    public invitedOwnerEmail?: string;
    public projectId: number = 0;
    public projectName?: string;
    public pricingId: number = 0;
    public pricingName?: string;
    public companyId?: number;
    public isPublished: boolean = false;

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Associations;
    }

    public get permissionsIdToCheck(): number {
        return this.id;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): Association {
        const association: Association = new Association();

        association.id = this.id;
        association.name = this.name;
        association.ownerId = this.ownerId;
        association.ownerEmail = this.ownerEmail;
        association.invitedOwnerEmail = this.invitedOwnerEmail;
        association.projectId = this.projectId;
        association.projectName = this.projectName;
        association.pricingId = this.pricingId;
        association.pricingName = this.pricingName;
        association.companyId = this.companyId;
        association.isPublished = this.isPublished;

        return association;
    }
}
